define('datakit/mixin/nested.object.mixin',['require','exports','module','underscore','backbone','../util/getobject'],function(require, exports, module) {
  var _ = require('underscore');
  var Backbone = require('backbone');
  var getobject = require('../util/getobject');

  var NestedObjectMixin = {

    initializeMixin: function() {
      this.registerGetter(this.isNestedAttribute, this.getNested);
      this.registerSetter(this.isNestedAttribute, this.setNested);
    },

    isNestedAttribute: function(attr) {
      return String(attr).indexOf('.') > -1;
    },

    getNested: function(attr) {
      return getobject.get(this, attr, false);
    },

    setNested: function(attr, value) {
      getobject.set(this, attr, value);
    }

  };
  module.exports = NestedObjectMixin;
});

